import { formatRouteTenantPath, hasPermission } from '@/utils'
require('dotenv').config();

export default {
    SET_NAV_MENU_ITEMS(state, features) {
        const menuItems = [
            {
              url: formatRouteTenantPath('/instances/list/choose-instance'),
              name: "ChatAttendance",
              slug: "chat-attendance",
              icon: "MessageCircleIcon",
              i18n: "ChatAttendance"
            },
            features.hasCloud ? {
              url: formatRouteTenantPath('/meta/template-messages'),
              name: "MetaTemplateMessages",
              slug: "meta-template-messages",
              icon: "BookmarkIcon",
              i18n: "MetaTemplateMessages"
            } : {},
            {
              url: null,
              name: "DataAndAnalytics",
              icon: "BarChartIcon",
              i18n: "DataAndAnalytics",
              submenu: [
                {
                  url: formatRouteTenantPath('/dashboard/analytics'),
                  name: "Analytics",
                  slug: "dashboard-analytics",
                  i18n: "Analytics"
                },
                {
                  url: formatRouteTenantPath('/dashboard/control-panel'),
                  name: "ControlPanel",
                  slug: "dashboard-control-panel",
                  i18n: "ControlPanel"
                },
                {
                  url: formatRouteTenantPath('/dashboard/report'),
                  name: "Report",
                  slug: "dashboard-report",
                  i18n: "Report"
                },
                features.hasOrders ? {
                  url: formatRouteTenantPath('/dashboard/report-order'),
                  name: "ReportOrder",
                  slug: "dashboard-report-order",
                  i18n: "ReportOrder"
                } : {},
                {
                  url: formatRouteTenantPath('/dashboard/security-report'),
                  name: "SecurityReport",
                  slug: "dashboard-security-report",
                  i18n: "SecurityReport"
                },
                {
                  url: formatRouteTenantPath('/dashboard/report-new'),
                  name: "ReportMetabase",
                  slug: "dashboard-report-new",
                  i18n: "ReportMetabase"
                },
                {
                  url: formatRouteTenantPath('/dashboard/report-nps'),
                  name: "ReportNPS",
                  slug: "dashboard-report-nps",
                  i18n: "ReportNPS"
                }
              ]
            },
            {
              url: null,
              name: "Campaigns",
              icon: "SendIcon",
              i18n: "Campaigns",
              submenu: [
                {
                  url: formatRouteTenantPath('/whatsapp/campaigns'),
                  name: 'WhatsApp',
                  slug: "whatsapp-campaigns",
                  i18n: "WhatsApp"
                },
                features.hasSmsCampaign ? {
                  url: formatRouteTenantPath('/sms/campaigns'),
                  name: 'Sms',
                  slug: "sms-campaigns",
                  i18n: "Sms"
                } : {},
                features.hasEmailCampaign ? {
                  url: formatRouteTenantPath('/email/campaigns'),
                  name: 'Email',
                  slug: "email-campaigns",
                  i18n: "Email"
                } : {},
              ]
            },
            {
              url: null,
              name: "CRM",
              icon: "BookIcon",
              i18n: "CRM",
              submenu: [
                {
                  url: formatRouteTenantPath('/crm/reasons'),
                  name: 'Métrica Inteligente',
                  slug: "reasons-list",
                  i18n: "SettingReasons"
                },
                {
                  url: formatRouteTenantPath('/crm/schedules'),
                  name: 'Mensagens Agendadas',
                  slug: "scheduled-message-list",
                  i18n: "ScheduledMessages"
                },
                {
                  url: formatRouteTenantPath('/crm/category'),
                  name: 'Category',
                  slug: "category-list",
                  i18n: "Category"
                },
                features.hasEmailCampaign ? {
                  url: formatRouteTenantPath('/crm/sender/emails'),
                  name: 'Email Remetentes',
                  slug: "email-list",
                  i18n: "CampaignSenderEmails"
                } : {},
                features.hasEmailCampaign ? {
                  url: formatRouteTenantPath('/crm/domain/emails'),
                  name: 'Domínios de Email',
                  slug: "domain-list",
                  i18n: "Domains"
                } : {},
              ]
            },
            features.hasMessaging ? {
              url: null,
              name: "Messaging",
              icon: "MailIcon",
              i18n: "Messaging",
              submenu: [
                {
                  url: formatRouteTenantPath('/messaging/relationship-rules'),
                  name: 'RelationshipRules',
                  slug: "relationship-rules-list",
                  i18n: "RelationshipRules"
                },
                {
                  url: formatRouteTenantPath('/messaging/relationship-templates'),
                  name: 'MetaTemplateMessages',
                  slug: "relationship-templates-list",
                  i18n: "MetaTemplateMessages"
                },
                {
                  url: formatRouteTenantPath('/messaging/relationship-rules-categories'),
                  name: 'RelationshipRulesCategory',
                  slug: "category-list",
                  i18n: "RelationshipRulesCategory"
                },
              ]
            } : {},
            {
              url: null,
              name: "Catalog",
              icon: "ShoppingBagIcon",
              i18n: "Catalog",
              submenu: features.hasCatalog ? [
                features.hasCatalog ? {
                  url: formatRouteTenantPath('/catalog/itens'),
                  name: 'Item',
                  slug: "catalog-itens",
                  i18n: "Item"
                }: {},
                features.hasCatalog ? {
                  url: formatRouteTenantPath('/catalog/collections'),
                  name: 'Colections',
                  slug: "catalog-collections",
                  i18n: "Colections"
                } : {},                                                 
              ] : [
                {
                  url: formatRouteTenantPath('/catalog/infos'),
                  name: "CatalogInfo",
                  slug: "catalog-infos",
                  i18n: "CatalogInfo"
                }
              ]
            },
            {
              url: null,
              name: "Orders",
              icon: "ShoppingCartIcon",
              i18n: "Orders",
              submenu: features.hasOrders ? [
                {
                  url: formatRouteTenantPath('/orders/product-orders'),
                  name: 'ProductOrders',
                  slug: "product-orders",
                  i18n: "ProductOrders"
                },
                {
                  url: formatRouteTenantPath('/orders/pre-orders'),
                  name: 'PreOrders',
                  slug: "product-pre-orders",
                  i18n: "PreOrders"
                },
                {
                  url: formatRouteTenantPath('/orders/products'),
                  name: 'Products',
                  slug: "products",
                  i18n: "Products"
                },
                features.hasServices ? {
                  url: formatRouteTenantPath('/orders/services'),
                  name: 'Services',
                  slug: "services",
                  i18n: "Services"
                } : {},
                {
                  url: formatRouteTenantPath('/orders/status'),
                  name: 'Status',
                  slug: "status",
                  i18n: "Status"
                },
                features.hasErps ? {
                  url: formatRouteTenantPath('/orders/erp-integrations'),
                  name: 'ERPIntegration',
                  slug: "erp-integration",
                  i18n: "ERPIntegration"
                } : {},
              ] : [
                {
                  url: formatRouteTenantPath('/orders/infos'),
                  name: "OrdersInfo",
                  slug: "orders-infos",
                  i18n: "OrdersInfo"
                }
              ]
            },
            {
              url: null,
              name: "MarIA",
              icon: "MariaIcon",
              i18n: "MarIA",
              submenu: features.hasMaria ? [
                {
                  url: formatRouteTenantPath('/new-chat-flows/triage/list'),
                  name: 'NewChatTriageFlowList',
                  slug: "new-chat-flows-triage-list",
                  i18n: "NewChatTriageFlowList"
                },
                {
                  url: formatRouteTenantPath('/new-chat-flows/promotions/list'),
                  name: 'PromotionsList',
                  slug: "new-chat-flows-promotions-list",
                  i18n: "PromotionsList"
                }
              ] : []
              // manter comentado
              /*[
                {
                  url: formatRouteTenantPath('/new-chat-flows/infos'),
                  name: "NewChatFlowsInfos",
                  slug: "new-chat-flows-infos",
                  i18n: "NewChatFlowsInfos"
                }
              ]*/ 
            },
            {
              url: null,
              name: "ConversationBot",
              icon: "SmileIcon",
              i18n: "ConversationBot",
              submenu: [
                {
                  url: formatRouteTenantPath('/chat-flows/passive/list'),
                  name: 'PassiveChatFlow',
                  slug: "chat-flows-passive-list",
                  i18n: "PassiveChatFlow"
                },
                {
                  url: formatRouteTenantPath('/chat-flows-active/active/list'),
                  name: 'ActiveChatFlow',
                  slug: "chat-flows-active-list",
                  i18n: "ActiveChatFlow"
                },
                {
                  url: formatRouteTenantPath('/configs/closing-messages'),
                  name: 'ClosingMessages',
                  slug: "settings-messages-closure",
                  i18n: "ClosingMessages"
                },
                {
                  url: formatRouteTenantPath('/configs/nps-messages'),
                  name: 'NPSMessages',
                  slug: "settings-messages-nps",
                  i18n: "NPSMessages"
                },
                {
                  url: formatRouteTenantPath('/configs/inactive-messages'),
                  name: 'InactiveMessages',
                  slug: "settings-messages-inactive",
                  i18n: "InactiveMessages"
                },
                {
                  url: formatRouteTenantPath('/configs/inactive-inbox-messages'),
                  name: 'InactiveInboxMessages',
                  slug: "settings-messages-inactive-inbox",
                  i18n: "InactiveInboxMessages"
                },
              ]
            },
            {
              url: null,
              name: "TargetAudience",
              icon: "UsersIcon",
              i18n: "TargetAudience",
              submenu: [
                {
                  url: formatRouteTenantPath('/customers/list'),
                  name: 'Customers',
                  slug: "customers-list",
                  i18n: "Customers"
                },
                {
                  url: formatRouteTenantPath('/numbers-blacklist/list'),
                  name: 'NumbersBlacklist',
                  slug: "numbers-blacklist-list",
                  i18n: "NumbersBlacklist"
                },
                {
                  url: formatRouteTenantPath('/knowledge/list'),
                  name: 'KnowledgeList',
                  slug: "knowledge-list",
                  i18n: "KnowledgeList"
                }
              ]
            },
            {
              url: null,
              name: "Settings",
              icon: "SettingsIcon",
              i18n: "Settings",
              submenu: [
                /*{
                  url: formatRouteTenantPath('/instances/list/connections'),
                  name: 'Instances',
                  slug: "instances-list",
                  i18n: "Instances"
                },*/
                {
                  url: formatRouteTenantPath('/configs/dynamic-settings'),
                  name: 'DynamicSettings',
                  slug: "configs-dynamic-settings",
                  i18n: "DynamicSettings"
                },
                {
                  url: formatRouteTenantPath('/configs/quick-answers'),
                  name: 'QuickAnswers',
                  slug: "settings-messages-quick",
                  i18n: "QuickAnswers"
                },
                {
                  url: formatRouteTenantPath('/configs/client-form'),
                  name: 'ClientForm',
                  slug: "configs-client-form",
                  i18n: "ClientForm"
                }
              ]
            },
            {
              url: null,
              name: "Access",
              icon: "UnlockIcon",
              i18n: "Access",
              submenu: [
                {
                  url: formatRouteTenantPath('/users/list'),
                  name: 'Users',
                  slug: "users-list",
                  i18n: "Users"
                },
                {
                  url: formatRouteTenantPath('/user-departments/list'),
                  name: 'UserDepartment',
                  slug: "user-departments-list",
                  i18n: "UserDepartment"
                },
                {
                  url: formatRouteTenantPath('/roles/list'),
                  name: "Roles",
                  slug: "roles-list",
                  i18n: "Roles",
                },
              ]
            },
        ];

        if (process.env.VUE_APP_DISABLE_PEDBOT_REFERENCES === 'true') {
          menuItems.push({
            url: null,
            name: "Help",
            icon: "HelpCircleIcon",
            i18n: "Help",
            submenu: [
              {
                url: formatRouteTenantPath('/help/support'),
                name: "Support",
                slug: "help-support",
                i18n: "Support",
              }
            ]
          })
        } else {
          menuItems.push({
            url: null,
            name: "Help",
            icon: "HelpCircleIcon",
            i18n: "Help",
            submenu: [
              {
                url: formatRouteTenantPath('/help/rules'),
                name: 'Rules',
                slug: "rules",
                i18n: "Rules"
              },
              {
                url: formatRouteTenantPath('/configs/contract-proposal-pdf'),
                name: 'ConfigsContractProposalPdf',
                slug: "configs-contract-proposal-pdf",
                i18n: "ContractProposalPdf"
              },
              {
                url: formatRouteTenantPath('/help/whatsapp-protocol'),
                name: "WhatsAppProtocol",
                slug: "help-whatsapp-protocol",
                i18n: "WhatsAppProtocol",
              },
              {
                url: formatRouteTenantPath('/help/training-videos'),
                name: "Training Videos",
                slug: "help-training-videos",
                i18n: "TrainingVideos",
              },
              // {
              //   url: formatRouteTenantPath('/help/user-manual'),
              //   name: "User Manual",
              //   slug: "help-user-manual",
              //   i18n: "UserManual",
              // },
              {
                url: formatRouteTenantPath('/help/support'),
                name: "Support",
                slug: "help-support",
                i18n: "Support",
              },
              {
                url: "https://www.pedbot-faq.net/",
                name: "FAQ",
                slug: "help-support",
                i18n: "FAQ",
                target: "FAQ"
              }
            ]
          })
        }

        const alwaysAllowed = [
            'help-support',
            'chat-attendance',
            'rules',
            'orders-infos',
            'sms-campaign-infos',
            //'new-chat-flows-infos', // manter comentado
            'catalog-infos',
            'email-campaign-infos'
        ]

        let allowedMenuItems = menuItems.filter(item => {
            if (item.url !== null) {
                return hasPermission(item.slug) ? item : false
            } else {
                item.submenu = item.submenu.filter(sub => {
                  if (alwaysAllowed.indexOf(sub.slug) >= 0) {
                      return item
                  }

                  return hasPermission(sub.slug) ? item : false
                })

                if (item.submenu.length === 0) {
                  return false
                }
            }

            return item
        })

        state.navMenuItems = allowedMenuItems
    }
}
